import { ReactComponent as ConfegrateActiveIcon } from '../../../assets/icons/sidebar/configeration-active.svg';
import { ReactComponent as ConfegrateIcon } from '../../../assets/icons/sidebar/configeration.svg';
import { ReactComponent as RevenueActiveIcon } from '../../../assets/icons/sidebar/revenue-active.svg';
import { ReactComponent as RevenueIcon } from '../../../assets/icons/sidebar/revenue.svg';
import { ReactComponent as AccountActiveIcon } from '../../../assets/icons/sidebar/sidebar-account-active.svg';
import { ReactComponent as AccountIcon } from '../../../assets/icons/sidebar/sidebar-account.svg';
import { ReactComponent as HomeActiveIcon } from '../../../assets/icons/sidebar/sidebar-home-active.svg';
import { ReactComponent as HomeIcon } from '../../../assets/icons/sidebar/sidebar-home.svg';
import { ReactComponent as QRCodeActiveIcon } from '../../../assets/icons/sidebar/sidebar-qrcode-active.svg';
import { ReactComponent as QRCodeIcon } from '../../../assets/icons/sidebar/sidebar-qrcode.svg';
import { ReactComponent as ReportActiveIcon } from '../../../assets/icons/sidebar/sidebar-report-active.svg';
import { ReactComponent as ReportIcon } from '../../../assets/icons/sidebar/sidebar-report.svg';
import { ReactComponent as StationActiveIcon } from '../../../assets/icons/sidebar/sidebar-station-active.svg';
import { ReactComponent as StationIcon } from '../../../assets/icons/sidebar/sidebar-station.svg';
import { MenuItem } from '../../../interface/menuItem-interfaces';
import getFirstSubdomain from '../../../shared-functions/DomainsplitFunction';
import { permissionCheck } from '../../../shared-functions/JWTDocodeFunction';

const subdomain = getFirstSubdomain();
const shouldHideAccessUtility = Boolean(subdomain);

/**
 * CPO Menus List
 * @returns {MenuItem[]} Array of CPO menu items
 */
const CPOMenu = (): MenuItem[] => [
  {
    id: 'dashboard',
    label: 'dashboard',
    url: '/ev-admin/dashboard',
    allow: permissionCheck('cpoDashboard'),
    svgIcon: <HomeIcon />,
    activeSvgIcon: <HomeActiveIcon />,
    permissionKey: 'cpoDashboard',
  },

  {
    id: 'accounts',
    label: 'accounts',
    allow: permissionCheck('cpoPartnerView') || permissionCheck('cpoUtilityProviderView'),
    svgIcon: <AccountIcon />,
    activeSvgIcon: <AccountActiveIcon />,
    children: [
      {
        id: 'partners',
        label: 'partners',
        url: '/ev-admin/accounts/partners',
        allow: permissionCheck('cpoPartnerView'),
        permissionKey: 'cpoPartnerView',
      },
      {
        id: 'utilityProvider',
        label: 'utilities',
        url: '/ev-admin/accounts/utility-provider',
        allow: permissionCheck('cpoUtilityProviderView'),
        permissionKey: 'cpoUtilityProviderView',
      },
    ],
  },

  {
    id: 'operations',
    label: 'operations',
    allow:
      permissionCheck('cpoChargingStationView') ||
      permissionCheck('cpoChargingPointView') ||
      permissionCheck('cpoSessionView'),
    svgIcon: <StationIcon />,
    activeSvgIcon: <StationActiveIcon />,
    children: [
      {
        id: 'chargingStations',
        label: 'stations',
        url: '/ev-admin/operations/charging-station/approved',
        allow: permissionCheck('cpoChargingStationView'),
        permissionKey: 'cpoChargingStationView',
        activeMatch: '/ev-admin/operations/charging-station',
      },

      {
        id: 'chargers',
        label: 'chargers',
        url: '/ev-admin/operations/chargers',
        allow: permissionCheck('cpoChargingPointView'),
        permissionKey: ['cpoChargingPointView'],
      },

      {
        id: 'sessions',
        label: 'sessions',
        url: '/ev-admin/operations/cpo-sessions',
        allow: permissionCheck('cpoSessionView'),
        permissionKey: 'cpoSessionView',
      },
      {
        id: 'ocppLogs',
        label: 'logs',
        url: '/ev-admin/operations/ocpp-logs',
        allow: true,
        permissionKey: 'ocppLogs',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'revenue',
    allow:
      permissionCheck('cpoTransactionView') ||
      permissionCheck('cpoRevenueSharingView') ||
      (permissionCheck('cpoCpoPayoutsView') && !shouldHideAccessUtility),
    svgIcon: <RevenueIcon />,
    activeSvgIcon: <RevenueActiveIcon />,
    children: [
      {
        id: 'transaction',
        label: 'transactions',
        url: '/ev-admin/revenue/cpo-transactions',
        allow: permissionCheck('cpoTransactionView'),
        permissionKey: 'cpoTransactionView',
      },

      {
        id: 'revenueSharing',
        label: 'revenueSharing',
        url: '/ev-admin/revenue/revenue-sharing',
        allow: permissionCheck('cpoRevenueSharingView'),
        permissionKey: 'cpoRevenueSharingView',
      },

      {
        id: 'payouts',
        label: 'cpoPayouts',
        url: '/ev-admin/revenue/cpo-payouts/approved',
        allow: permissionCheck('cpoCpoPayoutsView') && !shouldHideAccessUtility,
        permissionKey: 'cpoCpoPayoutsView',
        activeMatch: '/ev-admin/revenue/cpo-payouts',
      },
    ],
  },

  {
    id: 'configuration',
    label: 'configuration',
    allow:
      permissionCheck('cpoRevenueView') ||
      permissionCheck('cpoTariffView') ||
      permissionCheck('cpoPaymentGatewayView'),
    svgIcon: <ConfegrateIcon />,
    activeSvgIcon: <ConfegrateActiveIcon />,
    children: [
      //   {
      //     id: 'dynamicPricing',
      //     label: 'dynamicPricingApproval',
      //     url: '/ev-admin/dynamic-pricing/approved',
      //     allow: permissionCheck('dynamic_pricing'),
      //     permissionKey: 'dynamic_pricing',
      //   },
      // {
      //   id: 'dynamicPricing',
      //   label: 'dynamicPricingApproval',
      //   url: '/ev-admin/configuration/dynamic-pricing-approval/approved',
      //   allow: permissionCheck('dynamic_pricing'),
      //   permissionKey: 'dynamic_pricing',
      // },

      {
        id: 'revenueSharingManagement',
        label: 'revenueManagement',
        url: '/ev-admin/configuration/revenue-management',
        allow: permissionCheck('cpoRevenueView'),
        permissionKey: 'cpoRevenueView',
      },

      // {
      //   id: 'idleFees',
      //   label: 'idleFee',
      //   url: '/ev-admin/penalty-management/overrides',
      //   allow: true,
      //   permissionKey: 'idleFees',
      // },
      // {
      //   id: 'connectorRating',
      //   label: 'Connector Rating',
      //   url: '/ev-admin/connector-rating',
      //   allow: true,
      // },
      {
        id: 'tariffs',
        label: 'tariffs',
        url: '/ev-admin/tariffs',
        allow: permissionCheck('cpoTariffView'),
        permissionKey: 'cpoTariffView',
      },
      // {
      //   id: 'paymentGateway',
      //   label: 'paymentGateway',
      //   url: '/ev-admin/configuration/paymentGateway',
      //   allow: permissionCheck('cpoPaymentGatewayView'),
      //   permissionKey: 'cpoPaymentGatewayView',
      // },
    ],
  },

  {
    id: 'reports',
    label: 'reports',
    url: '/ev-admin/reports/energyReport',
    allow:
      permissionCheck('cpoEnergyReportView') ||
      permissionCheck('cpoRevenueReportView') ||
      permissionCheck('cpoBookingReportView') ||
      permissionCheck('cpoChargerUtilizationReportView') ||
      permissionCheck('cpoPerformanceReportView') ||
      permissionCheck('cpoMaintenanceReportView'),
    svgIcon: <ReportIcon />,
    activeSvgIcon: <ReportActiveIcon />,
    children: [
      {
        id: 'energyReport',
        label: 'energyReport',
        url: '/ev-admin/reports/energy-report',
        allow: permissionCheck('cpoEnergyReportView'),
        permissionKey: 'cpoEnergyReportView',
      },

      {
        id: 'revenueReport',
        label: 'revenueReport',
        url: '/ev-admin/reports/revenue-report',
        allow: permissionCheck('cpoRevenueReportView'),
        permissionKey: 'cpoRevenueReportView',
      },

      // {
      //   id: 'bookingsReport',
      //   label: 'bookingsReport',
      //   url: '/ev-admin/reports/bookings-report',
      //   allow: permissionCheck('cpoBookingReportView'),
      //   permissionKey: 'cpoBookingReportView',
      // },

      {
        id: 'chargerUtilizationReport',
        label: 'chargerUtilizationReport',
        url: '/ev-admin/reports/charger-utilization-report',
        allow: permissionCheck('cpoChargerUtilizationReportView'),
        permissionKey: 'cpoChargerUtilizationReportView',
      },

      // {
      //   id: 'performanceReport',
      //   label: 'performanceReport',
      //   url: '/ev-admin/reports/performance-report',
      //   allow: permissionCheck('cpoPerformanceReportView'),
      //   permissionKey: 'cpoPerformanceReportView',
      // },

      // {
      //   id: 'maintenanceReport',
      //   label: 'maintenanceReport',
      //   url: '/ev-admin/reports/maintenance-report',
      //   allow: permissionCheck('cpoMaintenanceReportView'),
      //   permissionKey: 'cpoMaintenanceReportView',
      // },
    ],
  },

  {
    id: 'tools',
    label: 'tools',
    allow:
      permissionCheck('cpoQrCodeGenerationView') ||
      permissionCheck('cpoCampaignManagementView') ||
      permissionCheck('cpoTariffCalculation'),
    svgIcon: <QRCodeIcon />,
    activeSvgIcon: <QRCodeActiveIcon />,
    children: [
      // {
      //   id: 'qrCode',
      //   label: 'qrCodeGenerator',
      //   url: '/ev-admin/tools/qr-code-generator',
      //   allow: permissionCheck('cpoQrCodeGenerationView'),
      //   permissionKey: 'cpoQrCodeGenerationView',
      // },

      // {
      //   id: 'campaigns',
      //   label: 'campaign',
      //   url: '/ev-admin/tools/campaign',
      //   allow: permissionCheck('cpoCampaignManagementView'),
      //   permissionKey: 'cpoCampaignManagementView',
      // },
      {
        id: 'tariffcalculator',
        label: 'tariffcalculator',
        url: '/ev-admin/tools/calculator',
        allow: permissionCheck('cpoTariffCalculation'),
        permissionKey: 'cpoTariffCalculation',
      },
      // {
      //   id: 'vlbc',
      //   label: 'vlbc',
      //   url: '/ev-admin/tools/vlbc',
      //   allow: true,
      // },
      {
        id: 'maintenance-scheduling',
        label: 'maintenanceScheduling',
        url: '/ev-admin/tools/maintenance-scheduling',
        allow: true,
      },
    ],
  },
];

export default CPOMenu;
